import {
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import logoImage from "../assets/logo.jpg";
import { MenuItem } from "./MenuItem";
import { useState } from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

type MobileNavBarProps = {
  menuItems: Array<MenuItem>;
};

const MobileNavBar = (props: MobileNavBarProps) => {
  const { menuItems } = props;

  const [open, setState] = useState(false);
  const navigate = useNavigate();

  const toggleDrawer =
    (open: boolean) => (event: React.SyntheticEvent<Element, Event>) => {
      setState(open);
    };

  return (
    <Grid
      container
      alignItems={"center"}
      sx={{
        minHeight: "64px",
        position: "sticky",
        zIndex: "1000",
        top: "0",
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <Grid item xs={6}>
        <Link
          to={"home"}
          spy={true}
          smooth={true}
          offset={-64}
          duration={500}
          key={"homeButton"}
        >
          <Button
            onClick={() => navigate("/")}
            sx={{ textTransform: "initial", padding: "0" }}
          >
            <Typography
              variant="body1"
              sx={{ display: "flex", fontWeight: "700" }}
            >
              <img src={logoImage} alt="Logo" style={{ width: 28, height: 28, borderRadius: "50%", marginRight: 6 }} />
              Ryan Dean
            </Typography>
          </Button>
        </Link>
      </Grid>
      <Grid
        item
        xs={2}
        sx={{
          position: "fixed",
          right: "0",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer(true)}
          sx={{
            mr: 2,
            display: {
              xs: "flex",
            },
          }}
        >
          <MenuIcon />
        </IconButton>

        <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
          <Box
            sx={{
              p: 2,
              height: 1,
              backgroundColor: (theme) => theme.palette.background.paper,
            }}
          >
            <IconButton sx={{ mb: 2 }} onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>

            <Box sx={{ mb: 2 }}>
              {menuItems.map((item) => (
                <Link
                  to={item.Path.split(" ").join("")}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  key={item.Text}
                >
                  <Box
                    sx={{
                      borderBottom: "1px solid",
                      borderColor: "rgba(255, 255, 255, 0.12)",
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    <ListItemButton
                      key={item.Text}
                      onClick={() =>
                        navigate("/", { state: { targetId: item.Path } })
                      }
                      style={{ alignItems: "center", display: "flex" }}
                    >
                      <ListItemText
                        sx={{
                          minHeight: "30px",
                          pt: 0,
                          pb: 0,
                          alignItems: "center",
                          display: "flex",
                        }}
                        primary={item.Text}
                      />
                    </ListItemButton>
                  </Box>
                </Link>
              ))}
              <Box
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "rgba(255, 255, 255, 0.12)",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <a
                  href={"/cv"}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  <ListItemButton
                    key={"CV"}
                    style={{ alignItems: "center", display: "flex" }}
                  >
                    <ListItemText
                      sx={{
                        minHeight: "30px",
                        pt: 0,
                        pb: 0,
                        alignItems: "center",
                        display: "flex",
                      }}
                      primary={"CV"}
                    />
                  </ListItemButton>
                </a>
              </Box>
            </Box>
          </Box>
        </Drawer>
      </Grid>
    </Grid>
  );
};

export default MobileNavBar;
